import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {NotificationURL} from "../config/api";
import axios from "axios";
import { getUserFriendlyError } from "@common/errorHandler";

const initialState = {
    status: "loading",
    token: ""
};

export const postNotification = createAsyncThunk(
    "notification/post",
    async (notificationData: any, {getState, rejectWithValue}) => {
        const existingToken = getState().notification?.token;
        if (existingToken === notificationData.fcmToken)
            return existingToken;
        try {
            const response = await axios.post(NotificationURL, notificationData);
            if (response.data.success) {
                return notificationData.fcmToken;
            } else {
                throw new Error(response.data.message);
            }
        } catch (error: any) {
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(postNotification.fulfilled, (state, action) => {
            state.status = "succeeded";
            state.token = action.payload
        });
    },
});

export default notificationSlice.reducer;
